import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(({ spacing }) => ({
  personalAccountDetailsTable: {
    marginBottom: spacing(4),
  },
  subSectionWrapper: {
    width: "45%",
  },
  subSectionBody: {
    padding: 10,
  },
  term: {
    padding: "0 20px",
  },
  dPIcon: {
    float: "left",
    height: 17,
    width: 17,
    marginRight: 8,
    backgroundSize: "contain",
    backgroundImage: "url(/favicon.png)",
  },
  detail: {
    color: colors.black,
    float: "right",
    padding: "0 20px",
  },
  gridSection: {
    marginBottom: 16,
  },
  containerGrid: {
    display: "flex",
    justifyContent: "space-between",
  },
}));

export default useStyles;
